// File types the Dokumente tab accepts. The backend stores PDFs only: images are converted to a
// PDF in the browser before upload (see ImagePdfConverterService).

// Mirrors MAX_PDF_SIZE_MB in backend/src/middleware/pdfUpload.ts — checked here only to fail fast.
const MAX_DOCUMENT_SIZE_MB = 20;
export const MAX_DOCUMENT_SIZE_BYTES = MAX_DOCUMENT_SIZE_MB * 1024 * 1024;
export const MAX_DOCUMENT_SIZE_LABEL = `${MAX_DOCUMENT_SIZE_MB} MB`;

export type DocumentKind = 'pdf' | 'image';

export interface DocumentFileType {
  label: string;
  kind: DocumentKind;
  mimeTypes: string[];
  extensions: string[];
}

export const DOCUMENT_FILE_TYPES: DocumentFileType[] = [
  { label: 'PDF', kind: 'pdf', mimeTypes: ['application/pdf'], extensions: ['.pdf'] },
  { label: 'JPG', kind: 'image', mimeTypes: ['image/jpeg'], extensions: ['.jpg'] },
  { label: 'JPEG', kind: 'image', mimeTypes: ['image/jpeg'], extensions: ['.jpeg'] },
  { label: 'PNG', kind: 'image', mimeTypes: ['image/png'], extensions: ['.png'] },
  { label: 'SVG', kind: 'image', mimeTypes: ['image/svg+xml'], extensions: ['.svg'] },
];

/** Value for the file input's accept attribute. */
export const DOCUMENT_UPLOAD_ACCEPT = [
  ...new Set(DOCUMENT_FILE_TYPES.flatMap(type => [...type.mimeTypes, ...type.extensions])),
].join(',');

/** 'pdf' or 'image' for an accepted file, otherwise null. Falls back to the extension, since some
 * systems report no MIME type. */
export function documentKind(file: File): DocumentKind | null {
  const name = file.name.toLowerCase();
  const type =
    DOCUMENT_FILE_TYPES.find(t => t.mimeTypes.includes(file.type)) ??
    DOCUMENT_FILE_TYPES.find(t => t.extensions.some(ext => name.endsWith(ext)));
  return type?.kind ?? null;
}

/** Whether a drag event carries files (not text or a link dragged from the page). */
export function isFileDrag(event: DragEvent): boolean {
  return event.dataTransfer?.types?.includes('Files') ?? false;
}
